import { render, staticRenderFns } from "./kindChooseViewzl.vue?vue&type=template&id=f9a6cd8a&scoped=true"
import script from "./kindChooseViewzl.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzl.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzl.vue?vue&type=style&index=0&id=f9a6cd8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a6cd8a",
  null
  
)

export default component.exports